export default __webpack_public_path__ + "cardModelNlp-real6ca6db.png";